module.exports = require('../impls/array-reverse/array-reverse.js').__arrayReverse;